import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import styled from 'styled-components'

const MapContainer = styled.div`
  img {
    height: auto;
  }
`

const Ubicaciones = ({ data }) => (
  <MapContainer>
    <Img
      style={{
        margin: '0 auto',
        marginTop: '3rem',
        maxWidth: 697,
      }}
      sizes={data.ubicaciones.sizes}
    />
  </MapContainer>
)

export default Ubicaciones

export const query = graphql`
  query UbicacionesImage {
    ubicaciones: imageSharp(id: { regex: "/mapa.png/" }) {
      sizes(maxWidth: 697) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/ubicaciones.js